import styled from 'styled-components';
import tw from 'twin.macro';

export const Container = styled.div`
  ${tw`container mx-auto px-4 lg:px-0 mb-4 lg:mb-12`}
`;

export const InnerContainer = styled.div`
  ${tw`pb-8 lg:pb-11 border-b lg:border-b-2 border-black grid grid-cols-1 lg:grid-cols-2 gap-x-10`}
`;

export const Author = styled.p`
  ${tw`text-sm mt-4 lg:mt-8`}
  color: ${({ theme }) => theme.colors.label};
  font-family: ${({ theme }) => theme.fontFamily.default};
`;

export const ShareContainer = styled.div`
  ${tw`hidden lg:block`}
`;

export const Thumbnail = styled.div`
  ${tw`hidden lg:block relative`}
`;
